<template>
 <div>
     <ClientsVueContainer />
 </div>
</template>

<script>
import ClientsVueContainer from "../containers/ClientsVueContainer.vue";
import { mapState, mapActions } from "vuex";
import { Helper } from "../helpers";
import { HTTP } from '../utils/HTTP';
import uid from "uid";
export default {
  name: "ClientsPage",
  components:{
      ClientsVueContainer
  },
  data() {
    return {
      
    };
  },
  computed: {
   
  },
  created() {
    
  },
  methods: {
    
  }
}


</script>

<style>
</style>